import React from 'react';
import { MailIcon, PhoneIcon, IdCardIcon, CopyIcon } from 'lucide-react';
import moment from 'moment';
import { Notify } from '../../../utils/functions';

const BasicInfo = ({ customer }) => {
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        Notify("Copied to clipboard", "success");
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <div>
                <h2 className="text-lg font-semibold mb-3 text-gray-700">Contact Information</h2>
                <div className="space-y-2">
                    <div className="flex items-center gap-1">
                        <span className="text-gray-500"><MailIcon size={18} /></span>
                        <span className="text-gray-800 font-medium">
                            {
                                customer.email ?
                                    <a href={`mailto:${customer.email}`} className="hover:text-orange-900 duration-300">
                                        {customer.email}
                                    </a>
                                    :
                                    "N/A"
                            }
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <span className="text-gray-500"><PhoneIcon size={18} /></span>
                        <span className="text-gray-800 font-medium">
                            {
                                customer.phone ?
                                    <a href={`tel:${customer.phone}`} className="hover:text-orange-900 duration-300">
                                        {customer.phone}
                                    </a>
                                    :
                                    "N/A"
                            }
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <span className="text-gray-500"><IdCardIcon size={18} /></span>
                        <span className="text-gray-800 font-medium">
                            {
                                customer.cnic ?
                                    customer.cnic
                                    :
                                    "N/A"
                            }
                        </span>
                    </div>
                </div>
            </div>

            <div>
                <h2 className="text-lg font-semibold mb-3 text-gray-700">Account Information</h2>
                <div className="space-y-2 text-xs">
                    <div className="flex items-start">
                        <span className="text-gray-500 w-32">User ID:</span>
                        <span className="text-gray-800 font-medium truncate flex items-center gap-1"><CopyIcon size={12} onClick={() => copyToClipboard(customer._id)} /> {customer._id || "N/A"}</span>
                    </div>
                    <div className="flex items-start">
                        <span className="text-gray-500 w-32">Auth UID:</span>
                        <span className="text-gray-800 font-medium truncate flex items-center gap-1"><CopyIcon size={12} onClick={() => copyToClipboard(customer.uid)} /> {customer.uid || "N/A"}</span>
                    </div>
                    <div className="flex items-start">
                        <span className="text-gray-500 w-32">Created On:</span>
                        <span className="text-gray-800 font-medium">
                            {customer.createdDate ? moment(customer.createdDate).format("LLL") : "N/A"}
                        </span>
                    </div>
                    <div className="flex items-start">
                        <span className="text-gray-500 w-32">Last Updated:</span>
                        <span className="text-gray-800 font-medium">
                            {customer.lastUpdated ? moment(customer.lastUpdated).format("LLL") : "N/A"}
                        </span>
                    </div>
                    <div className="flex items-start">
                        <span className="text-gray-500 w-32">Last Login:</span>
                        <span className="text-gray-800 font-medium">
                            {customer.lastLogin ? moment(customer.lastLogin).format("LLL") : "Never"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicInfo;